import { color, fontFamily } from "style/constants";

export default {
  root: {
    fontFamily: fontFamily.primary,
    color: color.DARKERGRAY,
    padding: "1.1rem 1rem",
    "&$disabled": {
      backgroundColor: color.WHITE,
      color: color.PALEGRAY,
      borderColor: color.GRAY,
      "&:hover": {
        borderColor: color.GRAY,
        cursor: "not-allowed"
      }
    }
  },
  outlined: {
    border: "1px solid",
    borderColor: color.PALEGRAY,
    borderRadius: "4px",
    "&:focus": {
      borderRadius: "4px"
    }
  },
  select: {
    "&:hover": {
      borderColor: color.BLUE
    }
  }
};
